export default __webpack_public_path__ + "static/media/FIREBIRD-ILP-PREA-Policy.517b670b.pdf";